module.exports = __webpack_public_path__ + "img/ic_add.6c805781.svg";